import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Message,
  InputNumber,
  IconButton,
  Icon,
} from 'rsuite'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import TargetDep6Table from './TargetDep6Table'
import { useForm, Controller } from 'react-hook-form'
import NumberFormat from 'react-number-format'

export default function TargetDep6Form({
  schema: _schema,
  // register,
  // errors,
  // Controller,
  // control,
  // setValue,
  // clearErrors,
  // onSubmit,
  //onDelete,
  onAddEditSuccess,
  ...props
}) {
  const { isDeleteError, isError, loading, scrollToComponent } = props

  const [schema, setSchema] = useState(_schema)
  const [dataList, setDataList] = useState([])
  const [isAdd, setIsAdd] = useState(false)
  const [editId, setEditId] = useState()
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)

  const [targetName, setTargetName] = useState()
  const [targetTotal, setTargetTotal] = useState()
  const [targetUnit, setTargetUnit] = useState()

  const { register, handleSubmit, watch, errors, control, setValue, clearErrors } = useForm()

  const selectedIdName = 'selectedId'

  useEffect(() => {
    setSchema(_schema)
    setIsAdd(isError)
    setIsDeleteFail(isDeleteError)
    setDataList(_schema?.target?.values || [])
  }, [_schema])

  useEffect(() => {
    onAddEditSuccess(_schema?.target?.values || [])
  }, [_schema.target.values])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const onAdd = () => {
    setValue(selectedIdName, -1)

    setTargetName('')
    setTargetTotal('')
    setTargetUnit('')
    setEditId('')
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)

    setValue(selectedIdName, '')

    scrollToComponent()
  }

  const handleEdit = (data) => {
    setValue(selectedIdName, data.id)
    setValue(schema.targetValue.name, data.targetName)
    setValue(schema.targetTotal.name, data.targetTotal)
    setValue(schema.targetUnit.name, data.targetUnit)

    setTargetName(data.targetName)
    setTargetTotal(data.targetTotal)
    setTargetUnit(data.targetUnit)
    setEditId(data.id)

    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    scrollToComponent()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)
    console.log('dataList', dataList)
    let arr = dataList
    let date = new Date().getTime()

    let _data = {
      enableDeleted: false,
      id: data.selectedId ? data.selectedId : `ADD_ID_${date}`,
      isDelete: false,
      targetName: data.targetValue,
      targetPercent: 0,
      targetTotal: data.targetTotal,
      targetUnit: data.targetUnit,
    }
    if (data.selectedId) {
      arr.forEach((item, index) => {
        if (item.id == data.selectedId) {
          item.targetName = data.targetValue
          item.targetTotal = data.targetTotal
          item.targetUnit = data.targetUnit

          arr.splice(index, 1, item)
        }
      })
    } else {
      arr.push(_data)
    }
    console.log('arr', arr)

    setDataList(arr)

    setValue(selectedIdName, -1)

    setTargetName('')
    setTargetTotal('')
    setTargetUnit('')
    setEditId('')
    setIsAdd(false)
    setIsSaveError(false)
    setIsDeleteFail(false)

    setValue(selectedIdName, '')

    onAddEditSuccess(arr)
  }

  const onDelete = (id) => {
    let arr = dataList
    arr.forEach((item, index) => {
      if (item.id === id) {
        if (id.indexOf('ADD') != -1) {
          arr.splice(index, 1)
        } else {
          arr[index].isDelete = true
        }
      }
    })
    setDataList(arr)
  }

  return (
    <>
      <Panel style={{ marginBottom: 5 }}>
        {schema.target.message && (
          <>
            {schema.target.message.map((item) => {
              return (
                <Row style={{ marginBottom: 10 }}>
                  <Message showIcon type={item.type} description={item.description} />
                </Row>
              )
            })}
          </>
        )}

        {isAdd && (
          <Form fluid>
            <Controller
              key={selectedIdName}
              name={selectedIdName}
              control={control}
              defaultValue={editId}
            />

            <Row style={{ marginBottom: 10 }}>
              <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.targetValue.name]} />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.targetTotal.name]} />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.targetUnit.name]} />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={12} lg={12}>
                <ControlLabel>
                  {requiredFiled(schema.targetValue.validators, schema.targetValue.label)}
                </ControlLabel>
                <Input
                  name={schema.targetValue.name}
                  disabled={schema.targetValue.disabled}
                  defaultValue={targetName}
                  placeholder={schema.targetValue.hint}
                  inputRef={register(isValidators(schema.targetValue.validators))}
                  onChange={(value) => {
                    setTargetName(value)
                  }}
                />
              </Col>

              <Col xs={24} sm={24} md={6} lg={6}>
                <ControlLabel>
                  {requiredFiled(schema.targetTotal.validators, schema.targetTotal.label)}
                </ControlLabel>
                <Controller
                  key={schema.targetTotal.name}
                  name={schema.targetTotal.name}
                  control={control}
                  rules={isValidators(schema.targetTotal.validators)}
                  defaultValue={targetTotal}
                  render={(props) => {
                    return (
                      // <InputNumber
                      //   min={0}
                      //   disabled={schema.targetTotal.disabled}
                      //   value={props.value}
                      //   placeholder={schema.targetTotal.hint}
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //     setTargetTotal(value)
                      //   }}
                      // />
                      <NumberFormat
                        className="rs-input"
                        disabled={schema.targetTotal.disabled}
                        placeholder={schema.targetTotal.hint}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                          setTargetTotal(value.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6}>
                <ControlLabel>
                  {requiredFiled(schema.targetUnit.validators, schema.targetUnit.label)}
                </ControlLabel>
                <Input
                  name={schema.targetUnit.name}
                  disabled={schema.targetUnit.disabled}
                  defaultValue={targetUnit}
                  placeholder={schema.targetUnit.hint}
                  inputRef={register(isValidators(schema.targetUnit.validators))}
                  onChange={(value) => {
                    setTargetUnit(value)
                  }}
                />
              </Col>
            </Row>

            {isSaveError && (
              <Row style={{ marginTop: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`บันทึก ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
                />
              </Row>
            )}

            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                <div>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon appearance="ghost" icon="save" className="bt-gost-icon-radius" />}
                    onClick={handleSubmit(onSubmit)}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {`บันทึก${schema.buttonText || ''}`}
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    icon={
                      <Icon
                        appearance="ghost"
                        icon="close"
                        className="bt-gost-icon-radius-cancel"
                      />
                    }
                    onClick={(e) => {
                      setIsAdd(false)
                      setIsSaveError(false)
                      scrollToComponent()
                    }}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {`ยกเลิก${schema.buttonText || ''}`}
                  </IconButton>
                </div>
              </Col>
            </Row>
          </Form>
        )}

        {!isAdd && (
          <Row style={{ marginTop: 10 }}>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
              <div>
                <IconButton
                  appearance="ghost"
                  icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                  onClick={onAdd}
                  style={{ marginRight: 5 }}
                >
                  {`เพิ่ม${schema.buttonText || ''}`}
                </IconButton>
              </div>
            </Col>
          </Row>
        )}

        {isDeleteFail && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={`ลบ${schema.buttonText ? schema.buttonText : ''}ไม่สำเร็จ`}
            />
          </Row>
        )}
        <Row style={{ marginTop: 10 }}>
          <TargetDep6Table
            schema={schema}
            dataList={dataList}
            isEdit={true}
            handleDelete={onDelete}
            handleEdit={handleEdit}
          />
        </Row>
      </Panel>
    </>
  )
}
